export const DISPATCH_PAYWALL_EVENT = 'openPayWallModal';
